import actions from './actions'
import caseRepo from './metaData/caseRepo'
export default {
  state: caseRepo,
  actions
}
